import { render, staticRenderFns } from "./IconTesting.vue?vue&type=template&id=381a3201&scoped=true"
import script from "./IconTesting.vue?vue&type=script&lang=js"
export * from "./IconTesting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a3201",
  null
  
)

export default component.exports